<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>升降机管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <!-- <span>设备名称：</span>
                <el-input placeholder="请输入设备名称" v-model="tableDataName"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>-->
                <el-button type="primary" @click="addRow()">添加设备</el-button>
                <!-- <el-button type="primary" @click="config()">参数配置</el-button> -->
                <!-- <router-link class="btnLef" :to="{name:'towerCraneData'}">数据统计</router-link> -->
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;" height="78.6vh">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80" type="index"></el-table-column>
                <el-table-column label="设备名称">
                    <template slot-scope="scope">
                    <a>{{ scope.row.name}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="厂家">
                    <template slot-scope="scope">
                    <span v-if="scope.row.machType=='1'">海智</span>
                    <span v-else-if="scope.row.machType=='3'">瞳声2</span>
                    <span v-else>瞳声</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备编号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.deviceId }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备状态">
                    <template slot-scope="scope">
                    <span v-if="scope.row.statusStr=='在线'" style="color:#36C635;">{{ scope.row.statusStr }}</span>
                    <span v-else style="color:#F56C6C;">{{ scope.row.statusStr }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="班组">
                    <template slot-scope="scope">
                    <span>{{ scope.row.teamsName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注">
                    <template slot-scope="scope">
                    <span>{{ scope.row.reason }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="时间">
                    <template slot-scope="scope">
                    <span>{{ scope.row.updateDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="200px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="设备名称：" prop="name">
                        <el-input
                        v-model="addForm.name"
                        placeholder="请输入设备名称"
                        autocomplete="off"
                        style="width:216px;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="厂家名称：" prop="machType">
                        <el-select v-model="addForm.machType">
                        <el-option
                            v-for="item in crane"
                            :key="item.val"
                            :label="item.perName"
                            :value="item.val"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号：" prop="deviceId">
                        <el-input
                        v-model="addForm.deviceId"
                        placeholder="请输入设备编号"
                        autocomplete="off"
                        style="width:216px;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="人脸识别编号:">
                        <el-select v-model="addForm.attendanceSn" @change="$forceUpdate()">
                        <el-option
                            v-for="item in groups"
                            :key="item.id"
                            :label="item.imei"
                            :value="item.imei"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="班组:">
                        <el-select v-model="addForm.teamsId" @change="$forceUpdate()">
                        <el-option
                            v-for="item in teams"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>-->
            </div>
        </div>
        <!-- 维护标准窗口 -->
        <el-dialog
            title="参数配置"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="60%"
        >
          <div class="config-con">
            <p class="config-con-item" v-for="(item,index) in configList" :key="index">
              <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
              <span style="display: inline-block;width: 7vw;">单位：（{{item.unit}}）</span>
              <span style="display: inline-block;width: 14vw;">设备报警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
              <span>默认使用系统设置</span>
              <el-switch
                v-model="item.status"
                inactive-text="关闭">
              </el-switch>
            </p>
          </div>
          <div slot="footer" class="dialog-footer" style="">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      projectId: '',
      crane: [
        { val: '1', perName: '海智' },
        { val: '2', perName: '瞳声' },
        { val: '3', perName: '瞳声2' },
      ],
      perName: '1',
      addLoading: false,
      dialogTitle: '编辑窗口', //弹出框标题
      labelPosition: 'right',
      groupId: util.session.get('groupId'),

      addForm: {
        id: '',
        name: '',
        machType: '1',
        deviceId: '',
        attendanceSn: '',
        teamsId: ''
      },
      editForm: [],
      radio: 1,
      search: '',
      searchData: '',
      addFormVisible: false,
      editFormVisible: false,
      tableDataName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      filterTableDataEnd: [],
      flag: false,
      dataText: '数据加载中...',
      groups: [],
      teams: [],
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        machType: [
          { required: true, message: '请选择厂家名称', trigger: 'blur' }
        ],
        deviceId: [
          { required: true, message: '请输入设备编号', trigger: 'blur' }
        ]
      },

      editFormVisible: false, // 弹出框是否显示
      configList:[
        {name:'重量',unit:'吨',val:'',status:true},
        {name:'重量百分比',unit:'百分比',val:'',status:true},
        {name:'人数',unit:'个',val:'',status:true},
        {name:'高度',unit:'米',val:'',status:true},
        {name:'高度百分比',unit:'百分比',val:'',status:true},
        {name:'速度',unit:'米每秒',val:'',status:true},
        {name:'倾斜度',unit:'度',val:'',status:true},
        {name:'倾斜百分比',unit:'百分比',val:'',status:true},
      ],
      configData:{
        id:'',
        projectId:'',
        projectName:'',
        weightSwitch:'',  //实时起重量   1开  2关
        weight:'',        //实时起重量
        weightPercentSwitch:'',    // 重量百分比   1开  2关
        weightPercent:'',          // 重量百分比
        personNumSwitch:'',   //实时人数开关
        personNum:'',         //实时人数
        heightSwitch:'',  //实时高度开关
        height:'',  //实时高度
        heightPercentSwitch:'',  // 高度百分比  开关
        heightPercent:'',     //高度百分比
        speedSwitch:'', //实时速度开关
        speed:'',    //实时速度
        tiltSwitch:'',//实时倾斜度 开关
        tilt:'',//实时倾斜度
        tiltPercentSwitch:'',// 倾斜百分比 开关
        tiltPercent:'',//倾斜百分比
        createBy:'',
      },
      hasConf:false,//判断是否已经有配置
    }
  },
  mounted() {
    this.getData()
    this.getList()
  },
  methods: {
    getList() {
      var that = this
      myHttp.getRecogByProjectId({
          projectId: util.session.get('groupId')
      }).then(
          function(resp) {
            if (resp.data.code == '200') {
              //  console.log(resp)
              var list = resp.data.data.pageInfo || []
              that.groups = list
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {}
        )
    },
    // 搜索数据 111
    doFilter() {
      this.currentPage = 1
      this.currentChangePage()
      this.flag = true
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`)
    //   this.currentPage = val
    //   this.getData()
    // },
    // // 监控当前页码
    // currentChangePage() {
    //   this.getData()
    // },

    // 获取数据
    getData() {
      var option = {
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getElevator(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.elevatorList || []
            that.tableDataEnd = list
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    // 获取班组
    getTeams() {
        // getTeamsListtz
        var that = this
        myHttp.getTeamsListtz({
          projectId: util.session.get('groupId')
        }).then(
          function(resp) {
            if (resp.data.code == '200') {
              that.teams = resp.data.data.teamsList || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    // 编辑数据
    handleEdit(index, row) {
      this.getTeams()
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.addForm.id = row.id
      this.addForm.name = row.name
      this.addForm.machType = row.machType
      this.addForm.deviceId = row.deviceId
      this.addForm.attendanceSn = row.attendanceSn
      this.addForm.teamsId = row.teamsId
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          myHttp.delElevator({
            id: row.id
          }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.getTeams()
      this.dialogTitle = '新增设备'
      ;(this.addFormVisible = true),
        (this.addForm = {
          id: '',
          name: '',
          machType: '1',
          deviceId: '',
          attendanceSn: '',
          teamsId: ''
        })
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.addForm.projectId = that.groupId
          // console.log(that.addForm.id)
          if (that.addForm.id == '') {
            //添加
            myHttp.createElevator(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            myHttp.updateElevator(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
      this.editFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },

    //数据转列表
    setConfigList(data){
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configList[i].val = data.weight
          this.configList[i].status = this.configData.weightSwitch=='2'?false:true
          // this.configData.pm2 = this.configList[i].val
          // this.configData.pm2Switch = this.configList[i].status?'1':'2'
        }else if(i==1){
          this.configList[i].val = data.weightPercent
          this.configList[i].status = this.configData.weightPercentSwitch=='2'?false:true
          // this.configData.pm10 = this.configList[i].val
          // this.configData.pm10Switch = this.configList[i].status?'1':'2'
        }else if(i==2){
          this.configList[i].val = data.personNum
          this.configList[i].status = this.configData.personNumSwitch=='2'?false:true
          // this.configData.noise = this.configList[i].val
          // this.configData.noiseSwitch = this.configList[i].status?'1':'2'
        }else if(i==3){
          this.configList[i].val = data.height
          this.configList[i].status = this.configData.heightSwitch=='2'?false:true
          // this.configData.temperature = this.configList[i].val
          // this.configData.temperatureSwitch = this.configList[i].status?'1':'2'
        }else if(i==4){
          this.configList[i].val = data.heightPercent
          this.configList[i].status = this.configData.heightPercentSwitch=='2'?false:true
          // this.configData.humidity = this.configList[i].val
          // this.configData.humiditySwitch = this.configList[i].status?'1':'2'
        }else if(i==5){
          this.configList[i].val = data.speed
          this.configList[i].status = this.configData.speedSwitch=='2'?false:true
          // this.configData.windSpeed = this.configList[i].val
          // this.configData.windSpeedSwitch = this.configList[i].status?'1':'2'
        }else if(i==6){
          this.configList[i].val = data.tilt
          this.configList[i].status = this.configData.tiltSwitch=='2'?false:true
        }else if(i==7){
          this.configList[i].val = data.tiltPercent
          this.configList[i].status = this.configData.tiltPercentSwitch=='2'?false:true
        }
      }
    },

    //配置
    config(){
      this.dialogTitle = '参数配置'
      this.editFormVisible = true
      this.configData.projectId = util.session.get('groupId')
      this.configData.projectName = this.projectName
      var that = this
      myHttp.selectElevatorCopy({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.ElevatorCopy
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    // 维护环境标准configData
    sumbitEditRow(formName) {
      var that = this
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configData.weight = this.configList[i].val
          this.configData.weightSwitch = this.configList[i].status?'1':'2'
        }else if(i==1){
          this.configData.weightPercent = this.configList[i].val
          this.configData.weightPercentSwitch = this.configList[i].status?'1':'2'
        }else if(i==2){
          this.configData.personNum = this.configList[i].val
          this.configData.personNumSwitch = this.configList[i].status?'1':'2'
        }else if(i==3){
          this.configData.height = this.configList[i].val
          this.configData.heightSwitch = this.configList[i].status?'1':'2'
        }else if(i==4){
          this.configData.heightPercent = this.configList[i].val
          this.configData.heightPercentSwitch = this.configList[i].status?'1':'2'
        }else if(i==5){
          this.configData.speed = this.configList[i].val
          this.configData.speedSwitch = this.configList[i].status?'1':'2'
        }else if(i==6){
          this.configData.tilt = this.configList[i].val
          this.configData.tiltSwitch = this.configList[i].status?'1':'2'
        }else if(i==7){
          this.configData.tiltPercent = this.configList[i].val
          this.configData.tiltPercentSwitch = this.configList[i].status?'1':'2'
        }
      }
      
      delete this.configData.createDate
      delete this.configData.updateDate
      if(this.hasConf){
        this.configData.updateBy = util.session.get('user').id
        myHttp.updateElevatorCopy(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }else{
        this.configData.createBy = util.session.get('user').id
        myHttp.addElevatorCopy(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }
    },
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 8vh );
    }
    .build-table::-webkit-scrollbar{
      width: 0 !important;
      height: 0 !important;
    }
    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>
<style>
    .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
    @import '../../../assets/css/common.css';
</style>